<template>
    <div class="container">
        <div class="main_bg dark-text">
            <h3>Encuentra<span> el vehículo de tus sueños</span></h3>
            <form @submit.prevent>
                <div class="row">
                    <div class="form-group col-md-3 col-sm-6 black_input">
                        <div class="select">
                            <select
                                class="form-control form-control-sm"
                                v-model="marca"
                                @change="onMarcaChange"
                                aria-label="Selecciona una marca"
                            >
                                <option value="">Marca</option>
                                <option
                                    style="text-transform: uppercase;"
                                    v-for="marca in marcas"
                                    :key="marca._id"
                                    :value="marca"
                                >
                                    {{ marca.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-3 col-sm-6 black_input">
                        <div class="select">
                            <select
                                class="form-control form-control-sm"
                                v-model="modelo"
                                @change="onModeloChange"
                                aria-label="Selecciona un modelo"
                            >
                                <option value="" :key="''">Modelo</option>
                                <option
                                    style="text-transform: uppercase;"
                                    v-for="modelo in modelos"
                                    :key="modelo.modelo"
                                    :value="modelo.modelo"
                                    >{{ modelo.modelo }}</option
                                >
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-3 col-sm-6 black_input">
                        <div class="select">
                            <select
                                class="form-control form-control-sm"
                                v-model="linea"
                                aria-label="Selecciona una linea"
                            >
                                <option value="">Linea</option>
                                <option
                                    style="text-transform: uppercase;"
                                    v-for="item in lineas"
                                    :key="item.lineas._id"
                                    :value="item.lineas.name"
                                >
                                    {{ item.lineas.name }} -
                                    {{ item.lineas.tipos_vehiculos.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-3 col-sm-6 black_input">
                        <div class="select">
                            <select
                                v-model="caja"
                                class="form-control form-control-sm"
                                aria-label="Selecciona la caja"
                            >
                                <option value="">Caja</option>
                                <option value="AT">Automática</option>
                                <option value="MT">Mecánica</option>
                                <option value="TP">Triptonica</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group col-md-9 col-sm-6 black_input">
                        <label class="form-label"
                            >Rango de Precio ($)
                            {{ priceRange.range[0] | formatNumber }} -
                            {{ priceRange.range[1] | formatNumber }}</label
                        >
                        <b-form-slider
                            style="width: 100%"
                            v-model="priceRange.range"
                            range
                            :min="priceRange.min"
                            :max="priceRange.max"
                            :step="100000"
                            aria-label="Rango de precio"
                            >Rango de precio
                        </b-form-slider>
                        <input
                            type="hidden"
                            name="price[]"
                            v-model="priceRange.range[0]"
                            aria-label="Precio Minimo"
                        />
                        <input
                            type="hidden"
                            name="price[]"
                            v-model="priceRange.range[1]"
                            aria-label="Precio Maximo"
                        />
                    </div>
                    <div class="form-group col-md-3 col-sm-6">
                        <button
                            @click="buscar"
                            class="btn btn-block mt-2"
                            aria-label="Buscar vehiculo"
                        >
                            Buscar
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import buscadorProvider from "providers/buscadorProvider";
import mainHelper from "helpers/main-helper";
export default {
    computed: {
        ...mapFields("buscador", ["marcas", "lineas", "modelos", "versiones"])
    },
    created() {
        buscadorProvider.getMarcas();
    },
    data: () => ({
        marca: "",
        modelo: "",
        linea: "",
        version: "",
        caja: "",
        priceRange: {
            min: 1000000,
            max: 500000000,
            range: [1000000, 500000000]
        },
        rangev: ""
    }),
    methods: {
        onMarcaChange() {
            this.modelo = "";
            this.modelos = [];
            this.linea = "";
            this.lineas = [];
            this.version = "";
            this.versiones = [];
            const idMarca = this.marca._id;
            buscadorProvider.getModelos(idMarca);
        },
        onModeloChange() {
            this.linea = "";
            this.lineas = [];
            this.version = "";
            this.versiones = [];
            const idMarca = this.marca._id;
            const modelo = this.modelo;
            buscadorProvider.getLineas(idMarca, modelo);
        },
        buscar() {
            const marca = this.marca.name;
            const linea = this.linea;
            const base_url = window.location.href;
            const action = mainHelper.getBuscadorUrl(
                base_url,
                marca.toUpperCase(),
                this.modelo,
                linea.toUpperCase(),
                this.caja,
                this.priceRange.range
            );
            window.location.href = action;
        }
    }
};
</script>

<style lang="scss">
.main_bg.dark-text {
    background: #fff;
    margin-bottom: 2rem;
    margin-top: 2rem;
}
#filter_form2 .form-label {
    color: #000000;
    display: block;
    font-size: 15px;
    font-weight: 700;
}

#filter_form2 .slider-selection {
    background-color: #fa2837;
}
#filter_form2 .slider-handle {
    background-color: #fa2837;
    background-image: none;
}
</style>
